import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import TestResultContainer from '../../containers/TestResult';
import i18n from '../../resources/i18n';
/**
 * テスト結果画面
 * @param props
 */
const TestResult: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('TestResult_0001')} />
			<TestResultContainer
				careerID={props.match.params.career_id}
				classID={props.match.params.class_id}
				testID={props.match.params.test_id}
				thistoryID={props.match.params.thistory_id}
				displayStyle={props.match.params.display_style}
				{...props}
			/>
		</>
	);
};

export default TestResult;



// WEBPACK FOOTER //
// ./src/pages/personal/TestResult.tsx